import React from 'react';
import { goToCheckout } from '../lib/checkout';
import { Sparkles } from 'lucide-react';
export function MegapackHighlight() {
  const handleCta = () => {
    goToCheckout('megapack');
  };
  const features = ['12 tomos completos', '180 ejercicios con secuencia', 'Física + Química + Físico-Química', 'Solucionarios incluidos', '6 Bonus estratégicos', 'Planificación de tareas anuales', 'Acceso inmediato PDF'];
  const eliteItems = [{
    label: 'Elite 1 - CIENCIA EN ACCION',
    text: '10 tareas modernas con el celular que tus alumnos realmente hacen — con rúbricas de corrección incluidas.'
  }, {
    label: 'Elite 2 - PROYECTOS TRANSVERSALES ESI / EAI',
    text: 'Los proyectos obligatorios de ESI y EAI para tu materia, ya redactados y listos para entregar a Dirección.'
  }];
  return <section className="bg-gray-100 py-12 md:py-16 px-4" data-id="element-145">
      <div className="max-w-xl mx-auto" data-id="element-146">
        <div className="bg-white border-4 border-sci-orange rounded-lg p-8 shadow-lg" data-id="element-147">
          <div className="text-sci-orange text-xs uppercase tracking-wide text-center mb-4 font-semibold" data-id="element-148">
            LA OPCIÓN MÁS ELEGIDA
          </div>

          <h3 className="text-2xl font-bold text-carbon text-center mb-6" data-id="element-149">
            MEGAPACK COMPLETO INCLUYE:
          </h3>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mb-6" data-id="element-150">
            {features.map((feature, i) => <div key={i} className="flex gap-2 items-start" data-id="element-151">
                <span className="text-bio-green flex-shrink-0" data-id="element-152">✅</span>
                <span className="text-gray-700 text-sm" data-id="element-153">{feature}</span>
              </div>)}
          </div>

          {/* Elite items — highlighted */}
          <div className="space-y-3 mb-6" data-id="element-154">
            {eliteItems.map((item, i) => <div key={i} className="bg-orange-50 border-l-4 border-sci-orange rounded-md p-3 flex gap-3 items-start" data-id="element-155">
                <Sparkles className="w-5 h-5 text-sci-orange flex-shrink-0 mt-0.5" data-id="element-156" />
                <div data-id="element-157">
                  <div className="text-sci-orange font-bold text-xs uppercase tracking-wide mb-1" data-id="element-158">
                    ⭐ {item.label}
                  </div>
                  <p className="text-gray-800 text-sm leading-relaxed" data-id="element-159">
                    {item.text}
                  </p>
                </div>
              </div>)}
          </div>

          <div className="text-center mb-6" data-id="element-160">
            <div className="text-3xl font-bold text-carbon" data-id="element-161">
              Solo por $27.990 ARS
            </div>
          </div>

          <button onClick={handleCta} className="w-full bg-sci-orange hover:bg-orange-600 text-white font-bold text-lg py-4 px-6 rounded-lg transition-colors" data-id="element-162">
            → QUIERO EL MEGAPACK COMPLETO
          </button>
        </div>
      </div>
    </section>;
}